import { useContext } from "react";
import { CheckoutContext } from "../../pages/Checkout";

function VisaForm() {
  const {amount, id} = useContext(CheckoutContext)
  return (
    <div className="container">
      <form action="http://192.168.0.106:9007/payment" method="post">
        <label htmlFor="transaction_reference">Transaction Reference</label>
        <input
          type="text"
          name="transactionReference"
          id="transaction_reference"
          defaultValue={id}
        />
        <label htmlFor="currency">Currency</label>
        <select id="currency" name="currency" defaultValue={"USD"}>
          <option value="USD">USD</option>
          <option value="EUR">Euro</option>
          <option value="POUND">POUND</option>
        </select>
        <label htmlFor="amount">Amount</label>
        <input type="text" name="amount" id="amount" defaultValue={amount}/>
        <input type="submit" value="Pay With Visa" />
      </form>
      <style>{`
        .container {
          border-radius: 5px;
          background-color: #f2f2f2;
          padding: 20px;
          width: 60%;
          margin: 200px auto;
        }

        input[type="text"],
        input[type="number"],
        select {
          width: 100%;
          padding: 12px 20px;
          margin: 8px 0;
          display: block;
          div   border: 1px solid #ccc;
          border-radius: 4px;
          box-sizing: border-box;
        }

        input[type="submit"] {
          width: 100%;
          background-color: #04aa6d;
          color: white;
          padding: 14px 20px;
          margin: 8px 0;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        input[type="submit"]:hover {
          background-color: #45a049;
        }
      `}</style>
    </div>
  );
}

export default VisaForm;
